import useGetUser from "src/hooks/useGetUser";
import useLocales from "src/hooks/useLocales";

import { defaultManagment, generalConfig, productsConfig } from "./dashboard/NavConfig";

export const useGetNavConfig = () => {
	const user = useGetUser();

	const { translate } = useLocales();

	const general = [
		...generalConfig,
		...productsConfig.filter((i) => user?.organization?.products.includes(i.id))
	];

	const newConfig: any = [
		{
			subheader: "General",
			items: general
		}
	];

	if (user && user?.role === "ROLE_VUMI") {
		newConfig.push({
			subheader: translate("nav_app_section.management"),
			isTranslate: true,
			items: defaultManagment
		});
	}

	return { navConfig: newConfig };
};
